import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/** Hover hint. Wraps the child so a disabled button can still show the tip. */
export function Hint({
  content,
  children,
  className,
}: {
  content?: React.ReactNode;
  children: React.ReactElement;
  className?: string;
}) {
  if (!content) return children;
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("inline-flex max-w-full", className)}>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-left">{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
